import cn from 'classnames';
import { compact } from 'lodash-es';
import { Button, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from "../../../constants";
import { useStore, useStoreActions } from "../../../contexts";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { useSwitchBusiness } from "../../../hooks/useSwitchBusiness";
import { selectors } from "../../../store/state-selectors";
import { HelpMenu } from "../HelpMenu";
import { InAppNotificationsButton } from "../InAppNotificationsButton";
import UserMenu from "../UserMenu/UserMenu";
import { BusinessSwitcher } from "./components/BusinessSwitcher/BusinessSwitcher";
import { BusinessSwitcherV2 } from "./components/BusinessSwitcher/BusinessSwitcherV2/BusinessSwitcherV2";
import { CreateAVendorAccount } from "./components/CreateAVendorAccount";
import styles from "./TopBar.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const getTopBarTID = () => getTestIds();
export function TopBar() {
  const userInfo = useStore(state => state.userInfo);
  const userId = useStore(selectors.user.id);
  const isVendor = useStore(selectors.user.isVendor);
  const businessName = useStore(selectors.user.businessName);
  const isAccountant = useStore(selectors.user.isAccountant);
  const isAnchorAdmin = useStore(selectors.user.isAnchorAdmin);
  const {
    switchBusiness,
    getPrevBusinessId
  } = useSwitchBusiness();
  const {
    logBI
  } = useStoreActions();
  const {
    CLIENT_TO_SERVICE_PROVIDER_IMPROVEMENTS
  } = useFeatureFlags();
  const hasAVendorAccount = userInfo === null || userInfo === void 0 ? void 0 : userInfo.hasAVendorAccount();
  const shouldShowCreateVendorAccount = !isVendor && !hasAVendorAccount;
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": getTopBarTID().TopBarTID.Root(),
    className: cn(styles.root, {
      [styles.accountant]: isAccountant,
      [styles.anchorAdmin]: isAnchorAdmin
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.start,
      children: [isAccountant && /*#__PURE__*/_jsxs("div", {
        className: styles.accountantSection,
        children: [/*#__PURE__*/_jsxs(Typography, {
          variant: "paragraph2",
          children: ["You are now logged in to", ' ', /*#__PURE__*/_jsx(Typography, {
            as: "span",
            variant: "paragraph2",
            weight: "normal",
            children: businessName
          })]
        }), /*#__PURE__*/_jsx(Button, {
          className: styles.backBtn,
          size: "small",
          skin: "primaryOutline",
          "data-testid": getTopBarTID().TopBarTID.BackToMyBusiness(),
          onClick: () => switchBusiness(getPrevBusinessId(), {
            newRoute: routes.agreementsDashboard
          }),
          children: "Back to my business"
        })]
      }), isAnchorAdmin && businessName && /*#__PURE__*/_jsx(AnchorAdmin, {
        companyName: businessName
      }), !isAccountant && !isAnchorAdmin && userInfo && /*#__PURE__*/_jsx(_Fragment, {
        children: CLIENT_TO_SERVICE_PROVIDER_IMPROVEMENTS ? /*#__PURE__*/_jsx(BusinessSwitcherV2, {
          userInfo: userInfo
        }) : /*#__PURE__*/_jsx(BusinessSwitcher, {
          userInfo: userInfo
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.end,
      "data-testid": getTopBarTID().TopBarTID.EndContainer(isVendor ? 'vendor' : 'client'),
      children: compact([{
        id: 'marketing-content',
        value: null
      }, !CLIENT_TO_SERVICE_PROVIDER_IMPROVEMENTS && shouldShowCreateVendorAccount && {
        id: 'create-vendor-account',
        value: /*#__PURE__*/_jsx(CreateAVendorAccount, {
          variant: "button",
          onClick: () => logBI(18100)
        })
      }, {
        id: 'help',
        value: userId && /*#__PURE__*/_jsx(HelpMenu, {
          userId: userId
        })
      }, isVendor && {
        id: 'in-app-notifications',
        value: /*#__PURE__*/_jsx(InAppNotificationsButton, {})
      }, userId && {
        id: 'user',
        value: /*#__PURE__*/_jsx(UserMenu, {
          userInfo: userInfo
        })
      }]).map(_ref => {
        let {
          id,
          value
        } = _ref;
        return /*#__PURE__*/_jsx("div", {
          "data-testid": getTopBarTID().TopBarTID.EndItem(id),
          className: styles.endItem,
          children: value
        }, id);
      })
    })]
  });
}
const AnchorAdmin = _ref2 => {
  let {
    companyName
  } = _ref2;
  return /*#__PURE__*/_jsxs(Typography, {
    variant: "paragraph2",
    breakWords: true,
    children: ["You are now logged as an Anchor Admin to", ' ', /*#__PURE__*/_jsx(Typography, {
      as: "span",
      weight: "bold",
      children: companyName
    })]
  });
};